<template>
  <el-table :data="items" size="small" class="mt-10" v-loading="loading">
    <el-table-column label="成品分类" prop="template.name"></el-table-column>
    <el-table-column label="成品编号" prop="code"></el-table-column>
    <el-table-column label="井号" prop="well.well_number">
      <template slot-scope="scope">
        <template> {{ scope.row.well.well_number || '未上井' }}</template>
      </template>
    </el-table-column>
    <el-table-column label="在井时间段">
      <template slot-scope="scope">
        <template v-if="scope.row.drill_well_id">
          {{ scope.row.receive_date }} ~
          {{ scope.row.send_date || '至今' }}</template
        >
        <template v-else>无</template>
      </template>
    </el-table-column>
    <el-table-column label="使用时长" prop="total_hour"></el-table-column>
  </el-table>
</template>

<script>
export default {
  props: {
    items: null,
    loading: false,
  },
  methods: {
    handleShowDetail(baseid, templateid, wellid) {
      let filter = {
        item_template_id: templateid,
        drill_well_id: wellid,
        base_id: baseid,
        page: 1,
        size: 10,
      }
      this.$router.push(`/instrument_items?filter=${JSON.stringify(filter)}`)
    },
  },
}
</script>